import { ImageWrapper, Small } from "@/lib/styles";
import styled from "styled-components";

export const Container = styled.div``;

export const ImageContainer = styled(ImageWrapper)<{
  $aspectRatio: number;
  $blur: boolean;
}>`
  padding-bottom: calc(${({ $aspectRatio }) => 1 / $aspectRatio} * 100%);
  margin-bottom: 1.5rem;
  width: 100%;
  background-color: transparent;

  img {
    opacity: ${({ $blur }) => ($blur ? "0.5" : "1")};
    transition: all 0.3s;
  }
`;

export const Heading = styled(Small)`
  text-transform: uppercase;
  font-weight: 700;
  text-align: center;
  width: 100%;
  display: block;
  line-height: 24px;
  background-color: ${({ theme }) => theme.colors.white};
  margin-bottom: 1.5rem; //24px
`;
